import { type Setup, type AuctionProduct, type PhoneValidation } from "./types";

import mainComp from "./auction-product.vue";
import { reactive, createApp, h } from "vue";
import { type OverwriteSettings } from "../../../commons/product/overwrite-settings";
import { mountReplace } from "../../../../utilities/mount-replace";

export function init(
    Vue: never,
    sel: string,
    props: {
        product: AuctionProduct;
        setup: Setup;
        phoneValidation?: PhoneValidation;
    },
    overwriteSettings: OverwriteSettings | undefined | null
) {
    props.product = reactive(props.product);
    props.setup = reactive(props.setup);
    if ("phoneValidation" in props && props.phoneValidation)
        props.phoneValidation = reactive(props.phoneValidation);

    const comp = createApp({
        name: "auction-product-page",
        render: function () {
            return h(mainComp, {
                product: props.product,
                setup: props.setup,
                phoneValidation: props.phoneValidation,
                overwriteSettings: overwriteSettings ?? undefined,
            });
        },
    });
    mountReplace(comp, sel);
    return comp;
}
